import { SdkMessageTypes } from '../constants';
import { HostedWebContentSdkService } from '../hosted-web-content-sdk';
import { IChatService, OpenConversationParams, ITelemetryService } from '../interfaces';
import { BaseMessageHandler } from './base-message-handler';

type MetaOsEventWithPossibleData = { data?: any };

/**
 * Responsible for handling chat messages
 */
export class ChatMessageHandler extends BaseMessageHandler {
  constructor(
    protected appSdkHost: HostedWebContentSdkService,
    protected chatService?: IChatService,
    telemetryService?: ITelemetryService
  ) {
    super(appSdkHost, telemetryService);
  }
  public initHandlers(): void {
    this.registerHandler(
      SdkMessageTypes.chat.openConversation,
      (_, params: OpenConversationParams) => {
        this.chatService!.clearListeners();
        this.chatService!.addEventListener('startConversation', (event: MetaOsEventWithPossibleData) =>
          this.appSdkHost.sendRequestMessage(
            'startConversation',
            event.data
              ? [event.data.subEntityId, event.data.conversationId, event.data.channelId, event.data.entityId]
              : []
          )
        );
        this.chatService!.addEventListener('closeConversation', (event: MetaOsEventWithPossibleData) =>
          this.appSdkHost.sendRequestMessage(
            'closeConversation',
            event.data
              ? [event.data.subEntityId, event.data.conversationId, event.data.channelId, event.data.entityId]
              : []
          )
        );
        this.chatService!.openConversation(params);
      },
      {
        isPrivate: true,
      }
    );
    this.registerHandler(
      SdkMessageTypes.chat.closeConversation,
      (_) => {
        this.chatService!.clearListeners();
        this.chatService!.closeConversation();
      },
      {
        isPrivate: true,
      }
    );
    this.registerHandler(SdkMessageTypes.chat.getChatMembers, (_) => this.chatService!.getChatMembers(), {
      isPrivate: true,
    });
  }

  protected validateDependencies() {
    if (!this.chatService) {
      throw 'No ChatService provided';
    }
  }
}
